import { logoImg } from 'configs/CustomColors';
import React from 'react';
import CustomScrollbars from 'util/CustomScrollbars';
import Navigation from "../../components/Navigation";

const SideBarContent = () => {
  let navigationMenus;

  if (sessionStorage.getItem("@Emissor/Type") === "PC") {
    navigationMenus = [
      {
        name: 'sidebar.dashboard.home',
        type: 'item',
        link: '/app/parceiro/admin/dashboard',
        icon: 'home'
      },
      {
        name: 'Usuários',
        type: 'item',
        link: '/app/parceiro/admin/users',
        icon: 'account-box'
      },
      {
        name: 'Empresas',
        type: 'item',
        link: '/app/parceiro/admin/companys',
        icon: 'balance'
      },
      {
        name: 'Pagamentos',
        type: 'item',
        link: '/app/parceiro/admin/payments',
        icon: 'store'
      },

    ];

  } else {

    navigationMenus = [
      {
        name: 'sidebar.dashboard.novaVenda',
        type: 'item',
        link: '/app/dashboard',
        icon: 'home'
      },
      {
        name: 'sidebar.dashboard.vendas',
        type: 'collapse',
        icon: 'card',
        children: [
          {
            name: 'sidebar.dashboard.vendas.todas',
            type: 'item',
            link: '/app/vendas',
            icon: 'shopping-cart'
          },
          // {
          //   name: 'sidebar.dashboard.fast',
          //   type: 'item',
          //   link: '/app/venda/rapida',
          //   icon: 'money'
          // },
          {
            name: 'sidebar.dashboard.vendas.consultar',
            type: 'item',
            link: '/app/fiscal/consulta',
            icon: 'search'
          },
          // {
          //   name: 'Cancelar',
          //   type: 'item',
          //   link: '/app/fiscal/cancelamento',
          //   icon: 'close-circle'
          // },
          {
            name: 'sidebar.dashboard.vendas.inutilizar',
            type: 'item',
            link: '/app/fiscal/inutilizar',
            icon: 'alert-triangle'
          },
          {
            name: 'sidebar.dashboard.vendas.cartaCorrecao',
            type: 'item',
            link: '/app/fiscal/carta_correcao',
            icon: 'edit'
          },
          {
            name: 'sidebar.dashboard.vendas.nfccom',
            type: 'item',
            link: '/app/fiscal/nfcom',
            icon: 'router'
          },
        ]
      },
      {
        name: 'sidebar.dashboard.produtoServico',
        type: 'item',
        link: '/app/produtos_servicos',
        icon: 'check-square'
      },
      {
        name: 'sidebar.dashboard.clientes',
        type: 'item',
        link: '/app/clientes',
        icon: 'account-box'
      },
      {
        name: 'sidebar.dashboard.transportadoras',
        type: 'item',
        link: '/app/transportadoras',
        icon: 'local-shipping'
      },
      {
        name: 'sidebar.dashboard.relatorios',
        type: 'item',
        link: '/app/reports',
        icon: 'file'
      },
      {
        name: 'sidebar.dashboard.configSistema',
        type: 'collapse',
        icon: "settings",
        children: [
          {
            name: 'sidebar.dashboard.configSistema.operacao',
            type: 'item',
            link: '/app/natureza_da_operacao',
            icon: 'chart'
          },
          {
            name: 'sidebar.dashboard.configSistema.unMedida',
            type: 'item',
            link: '/app/unidade_de_medida',
            icon: 'ruler'
          },
          // {
          //   name: 'sidebar.dashboard.configSistema.mensalidade',
          //   type: 'item',
          //   link: '/app/plans-client',
          //   icon: 'store'
          // },
          {
            name: 'sidebar.dashboard.configSistema.pagamento',
            type: 'item',
            link: '/app/formas_de_pagamento',
            icon: 'swap-alt'
          },
          {
            name: 'sidebar.dashboard.configSistema.tributacoes',
            type: 'item',
            link: '/app/tributacoes',
            icon: 'money-off'
          },

          {
            name: 'sidebar.dashboard.configSistema.config',
            type: 'item',
            link: '/app/configuracoes_nota_fiscal',
            icon: 'device-hub'
          },
        ]
      },

    ];
  }

  return (
    <CustomScrollbars className="scrollbar">
      <Navigation menuItems={navigationMenus} />
    </CustomScrollbars >
  );
};

export default SideBarContent;